export const getParentWindow = (rootWindow = window) => {
  const isInIframe = rootWindow.self !== rootWindow.top;
  return isInIframe ? rootWindow.top : rootWindow;
};
export const getZorse = (rootWindow = window) => {
  var _topWindow$hubspot;
  const topWindow = getParentWindow(rootWindow);
  return topWindow === null || topWindow === void 0 || (_topWindow$hubspot = topWindow.hubspot) === null || _topWindow$hubspot === void 0 ? void 0 : _topWindow$hubspot.zorse;
};